<template lang="pug">
  v-slide-y-transition(mode="out-in")

    v-container(fluid, v-if="!isLoading()")

      confirm(ref="deleteConfirm")

      v-card
        v-card-text
          v-container(fluid, grid-list-sm)
            v-layout(row, wrap, v-if="images.length > 0")
              v-flex.delete-button-container(xs3, v-for="image in images", :key="image.id")
                v-btn.delete-button(fab, color="red", dark, small, @click="handleDelete(image)")
                  v-icon delete
                v-card(flat tile)
                  v-img(:src="`//${STORAGE_HOST}/${accommodationId}/${image.file}`" height="150px")
            v-alert(color="info", outline icon="info", :value="true", v-else) Todavía no hay imágenes
          v-divider.mt-2.mb-2
          custom-uploader(@uploaded="handleUploaded", :multiple="true", accept="image/jpeg, image/png", :endpoint="`/accommodations/${accommodationId}/images`")

    v-container(fluid fill-height v-else)
      v-layout(flex align-center justify-center)
        v-progress-circular(indeterminate, color="primary", :size="128", :width="2")
</template>

<style>
  .delete-button-container {
    position: relative;
  }

  .delete-button {
    position: absolute;
    z-index: 1;
    right: 5px;
    bottom: 5px;
  }
</style>

<script>
  import Uploader from '@/components/Uploader';

  export default {
    components: {
      'custom-uploader': Uploader,
    },
    data() {
      return {
        loading: {
          images: false,
        },
        accommodationId: this.$route.params.accommodationId,
        images: [],
        STORAGE_HOST: process.env.STORAGE_HOST,
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      isLoading() {
        return this.loading.images;
      },
      fetchData() {
        this.loading.images = true;
        api.get(`/accommodations/${this.accommodationId}/images`).then((res) => {
          this.images = res.data;
        }).catch(this.handleError)
        .finally(() => { this.loading.images = false; });
      },
      handleDelete(image) {
        this.$refs.deleteConfirm.open('Eliminar', '¿Estás seguro?').then((confirm) => {
          if (confirm) {
            api.delete(`/accommodations/${this.accommodationId}/images/${image.id}`).then(() => {
              this.images.splice(this.images.indexOf(image), 1);
            }).catch(this.handleError);
          }
        });
      },
      handleUploaded(image) {
        this.images.push(image);
      },
      handleError(err) {
        // eslint-disable-next-line no-console
        console.error(err);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/Accommodations/AccommodationImages.vue